/*
  ============================================================
  COVER YOU — Délais de livraison, guide des tailles et FAQ
  Asset : assets/cy-delivery.js
  Utilisé par : blocks/cy-delivery-journey.liquid + snippets/cy-help-drawers.liquid
                + blocks/cy-size-link.liquid (fiche produit)
                sections/cy-faq.liquid (page /pages/aide)
  Sources des délais (31-10-2026) :
    Printful : fabrication 2 à 5 j ouvrés ; transport France 2 à 4 j, UE 4 à 10 j au total.
    TPOP : fabrication lancée sous 2 à 4 j ; transport France 2 à 3 j, UE 3 à 10 j,
           reste du monde 5 à 14 j ; pas de livraison aux États-Unis.
    Autres ateliers (Spreadconnect, Tunetoo) : délai global des CGV, 4 à 11 j ouvrés.
  Version : 1.2 — 03-11-26
    v1.2 : liens #theme-<onglet> (menu déroulant FAQ de l'en-tête) : ouvrent la page
           Aide sur l'onglet voulu (commande, livraison, retours, tailles, matieres, cy).
           ROLLBACK v1.2 → v1.1 : retirer le bloc « v1.2 » de openFromHash().
    v1.1 : tiroirs « Quand vais-je le recevoir ? » et « Trouver ma taille » sur la
           fiche produit (la cliente ne quitte plus la page) ; bouton « Choisir le M »
           qui sélectionne la taille conseillée. Calculs estimate() et advise()
           partagés avec la page Aide (même résultat qu'en v1.0).
  ROLLBACK v1.1 → v1.0 : recopier assets/sauvegarde-2026-11-02-cy-delivery-v1.0.js.txt
  ROLLBACK complet : retirer le bloc et la section qui chargent ce fichier, puis le supprimer.
  ============================================================
*/
(() => {
  if (window.CYDelivery) return;

  /* Jours fériés français (jours ouvrés exclus du calcul) */
  const HOLIDAYS = [
    '2026-11-01', '2026-11-11', '2026-12-25',
    '2027-01-01', '2027-03-29', '2027-05-01', '2027-05-06', '2027-05-08', '2027-05-17',
    '2027-07-14', '2027-08-15', '2027-11-01', '2027-11-11', '2027-12-25',
    '2028-01-01', '2028-04-17', '2028-05-01', '2028-05-08', '2028-05-25', '2028-06-05',
    '2028-07-14', '2028-08-15', '2028-11-01', '2028-11-11', '2028-12-25'
  ];

  /* [fabrication min, fabrication max, transport min, transport max] en jours ouvrés */
  const ATELIERS = {
    printful: { label: 'Atelier Printful, Riga ou Barcelone', fr: [2, 5, 2, 4], ue: [2, 5, 2, 5], monde: null },
    tpop: { label: 'Atelier TPOP, dans le Gard', fr: [2, 4, 2, 3], ue: [2, 4, 3, 10], monde: [2, 4, 5, 14], noUS: true },
    autre: { label: 'Atelier partenaire', fr: null, ue: null, monde: null }
  };

  const iso = (d) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

  function addBusinessDays(from, n) {
    const d = new Date(from);
    let added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6 && !HOLIDAYS.includes(iso(d))) added += 1;
    }
    return d;
  }

  const fmtLong = (d) => d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'long' });
  const fmtShort = (d) => d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });

  function compute(key, zone, from = new Date()) {
    const atelier = ATELIERS[key] || ATELIERS.autre;
    const range = atelier[zone];
    if (!range) {
      if (zone === 'fr') return { mode: 'global', atelier, lo: addBusinessDays(from, 4), hi: addBusinessDays(from, 11) };
      return { mode: 'none', atelier };
    }
    const [p1, p2, t1, t2] = range;
    const ship1 = addBusinessDays(from, p1);
    const ship2 = addBusinessDays(from, p2);
    return {
      mode: 'full', atelier, p1, p2,
      ship1, ship2, d1: addBusinessDays(ship1, t1), d2: addBusinessDays(ship2, t2)
    };
  }

  /* Tableaux de mesures (vêtement à plat, en cm) */
  const SIZES = {
    tee: { cols: ['Largeur poitrine', 'Longueur'], rows: [['S', 49.5, 69], ['M', 53.5, 73], ['L', 56.5, 75], ['XL', 59.5, 77], ['2XL', 63.5, 79], ['3XL', 67.5, 81], ['4XL', 72.5, 83], ['5XL', 77.5, 84]] },
    hood: { cols: ['Largeur poitrine', 'Longueur'], rows: [['S', 51.6, 68], ['M', 54.1, 71.9], ['L', 56.9, 74], ['XL', 60, 76], ['2XL', 63, 78]] },
    sw: { cols: ['Largeur poitrine', 'Longueur'], rows: [['S', 51, 68], ['M', 54, 70], ['L', 57, 72], ['XL', 60, 74], ['XXL', 63, 76]] },
    ls: { cols: ['Largeur', 'Longueur'], rows: [['S', 49, 70], ['M', 52, 72], ['L', 55, 74], ['XL', 58, 76], ['2XL', 61, 78], ['3XL', 64, 80]] }
  };
  const n1 = (x) => String(x).replace('.', ',');
  const norm = (s) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const escapeHTML = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);

  /* ---------- Calculs partagés (page Aide + tiroirs de la fiche) — v1.1 ---------- */

  /* Estimation par atelier et zone : étapes [titre, valeur, détail], verdict, mention */
  function estimate(key, zone, now = new Date()) {
    const r = compute(key, zone, now);
    const first = ['Commande', 'Aujourd’hui', fmtLong(now)];
    if (r.mode === 'full') {
      return {
        steps: [first,
          ['Fabrication', `${r.p1} à ${r.p2} jours`, r.atelier.label],
          ['Expédition', fmtShort(r.ship1), `au plus tard le ${fmtLong(r.ship2)}`],
          ['Chez vous', fmtShort(r.d1), `au plus tard le ${fmtLong(r.d2)}`]],
        verdict: `Commandée aujourd’hui, votre pièce arrive <strong>entre le ${fmtLong(r.d1)} et le ${fmtLong(r.d2)}</strong>.`,
        fine: 'Jours ouvrés, hors week-ends et jours fériés français. Estimation des ateliers, non garantie : le transporteur peut ajouter un jour ou deux.'
          + (zone === 'monde' ? ' Droits de douane possibles à l’arrivée.' : '')
          + (zone === 'monde' && r.atelier.noUS ? ' Cet atelier ne livre pas les États-Unis.' : '')
      };
    }
    if (r.mode === 'global') {
      return {
        steps: [first, ['Fabrication', 'En atelier', r.atelier.label], ['Transport', 'Suivi par e-mail', ''],
          ['Chez vous', fmtShort(r.lo), `au plus tard le ${fmtLong(r.hi)}`]],
        verdict: `Livraison estimée <strong>entre le ${fmtLong(r.lo)} et le ${fmtLong(r.hi)}</strong>.`,
        fine: 'Délai global indiqué dans nos CGV, de la commande à la livraison, en jours ouvrés.'
      };
    }
    return {
      steps: [first, ['Fabrication', 'En atelier', r.atelier.label], ['Transport', 'Selon le pays', 'suivi par e-mail'],
        ['Chez vous', 'Variable', zone === 'monde' ? 'droits de douane possibles' : '']],
      verdict: 'Le délai dépend du pays de livraison.',
      fine: 'Le délai précis figure dans l’e-mail d’expédition, avec le lien de suivi.'
    };
  }

  /* Conseil de taille : meilleure ligne du tableau + phrase d'explication (null sans mesure) */
  function advise(m, w, fit) {
    if (Number.isNaN(w)) return null;
    const target = w + (fit === 'near' ? -2 : fit === 'ample' ? 2.5 : 0);
    const best = m.rows.reduce((a, r) => (Math.abs(r[1] - target) < Math.abs(a[1] - target) ? r : a));
    const i = m.rows.indexOf(best);
    const diff = best[1] - w;
    let note = Math.abs(diff) < 1 ? 'Pratiquement la même largeur que votre haut.'
      : diff > 0 ? `${n1(Math.round(diff * 10) / 10)} cm de plus que votre haut, un peu plus d’aisance.`
        : `${n1(Math.round(-diff * 10) / 10)} cm de moins que votre haut, un peu plus ajusté.`;
    if (w < m.rows[0][1] - 2) note += ` Votre mesure est sous la plus petite taille : le ${m.rows[0][0]} sera ample.`;
    else if (w > m.rows[m.rows.length - 1][1] + 2) note += ' Votre mesure dépasse la plus grande taille de ce modèle : écrivez-nous.';
    else {
      const nb = fit === 'near' ? m.rows[i + 1] : m.rows[i - 1];
      if (nb && Math.abs(nb[1] - target) < 2) note += ` Entre deux tailles : le ${nb[0]} (${n1(nb[1])} cm) sera ${nb[1] > best[1] ? 'plus ample' : 'plus près du corps'}.`;
    }
    return { best, note };
  }

  const sizeTable = (m, best) =>
    `<tr><th scope="col">Taille</th><th scope="col">${m.cols[0]} (cm)</th><th scope="col">${m.cols[1]} (cm)</th></tr>`
    + m.rows.map((r) => `<tr${best && r[0] === best[0] ? ' class="is-best"' : ''}><td>${r[0]}</td><td>${n1(r[1])}</td><td>${n1(r[2])}</td></tr>`).join('');

  window.CYDelivery = { ATELIERS, SIZES, compute, estimate, advise, addBusinessDays, fmtLong, fmtShort };

  /* ---------- Fiche produit : parcours de la pièce ---------- */
  function initJourney(root) {
    const r = compute(root.dataset.atelier, 'fr');
    const set = (name, html) => {
      const el = root.querySelector(`[data-cy="${name}"]`);
      if (el) el.innerHTML = html;
    };
    if (r.mode === 'full') {
      set('ship', r.ship1.getTime() === r.ship2.getTime() ? fmtShort(r.ship1) : `${fmtShort(r.ship1)} – ${fmtShort(r.ship2)}`);
      set('arrive', `${fmtShort(r.d1)} – ${fmtShort(r.d2)}`);
      set('verdict', `Commandée aujourd'hui, elle arrive chez vous <strong>entre le ${fmtLong(r.d1)} et le ${fmtLong(r.d2)}</strong>. Livraison offerte en France.`);
    } else if (r.mode === 'global') {
      set('arrive', `${fmtShort(r.lo)} – ${fmtShort(r.hi)}`);
      set('verdict', `Commandée aujourd'hui, elle arrive chez vous <strong>entre le ${fmtLong(r.lo)} et le ${fmtLong(r.hi)}</strong>. Livraison offerte en France.`);
    }
    root.classList.add('is-dated');
  }

  /* ---------- Fiche produit : tiroirs livraison et taille — v1.1 ---------- */
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let lockedOverflow = '';

  function openDrawer(dlg) {
    if (dlg.open) return;
    lockedOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dlg.dispatchEvent(new CustomEvent('cy:drawer-open'));
    dlg.showModal();
    requestAnimationFrame(() => requestAnimationFrame(() => dlg.classList.add('is-open')));
  }

  function closeDrawer(dlg) {
    if (!dlg.open) return;
    dlg.classList.remove('is-open');
    const done = () => {
      dlg.close();
      document.documentElement.style.overflow = lockedOverflow;
    };
    if (reduceMotion()) done();
    else setTimeout(done, 350);
  }

  /* Écritures équivalentes entre le tableau et les options Shopify */
  const SIZE_ALIASES = { '2XL': ['XXL'], XXL: ['2XL'], '3XL': ['XXXL'], XXXL: ['3XL'] };

  function findSizeInput(optionName, size) {
    const key = (v) => v.toLowerCase().replace(/\s+/g, ''); /* « 2 XL » = « 2XL » */
    const values = [size, ...(SIZE_ALIASES[size] || [])].map(key);
    const radio = [...document.querySelectorAll('input[type="radio"]')]
      .find((i) => i.name.startsWith(`${optionName}-`) && values.includes(key(i.value)));
    if (radio) return { kind: 'radio', el: radio };
    const sel = [...document.querySelectorAll('select')].find((s) => s.name === `options[${optionName}]`);
    const opt = sel && [...sel.options].find((o) => values.includes(key(o.value)));
    return opt ? { kind: 'select', el: sel, value: opt.value } : null;
  }

  function initDeliveryDrawer(dlg) {
    const zones = [...dlg.querySelectorAll('[data-zone]')];
    let zone = 'fr';
    const step = ([k, v, s], end) => `<li class="cy-journey__step${end ? ' cy-journey__step--end' : ''}"><span class="cy-journey__k">${k}</span><span class="cy-journey__v">${v}</span>${s ? `<span class="cy-journey__s">${s}</span>` : ''}</li>`;
    const render = () => {
      const e = estimate(dlg.dataset.atelier, zone);
      dlg.querySelector('[data-cy-track]').innerHTML = e.steps.map((s, i) => step(s, i === e.steps.length - 1)).join('');
      dlg.querySelector('[data-cy-verdict]').innerHTML = e.verdict;
      dlg.querySelector('[data-cy-fine]').textContent = e.fine;
    };
    zones.forEach((b) => b.addEventListener('click', () => {
      zone = b.dataset.zone;
      zones.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      render();
    }));
    dlg.addEventListener('cy:drawer-open', render); /* dates recalculées à chaque ouverture */
    render();
  }

  function initSizeDrawer(dlg) {
    const m = SIZES[dlg.dataset.model];
    if (!m) return;
    const optionName = dlg.dataset.option;
    const width = dlg.querySelector('[data-cy-width]');
    const fits = [...dlg.querySelectorAll('[data-fit]')];
    const out = dlg.querySelector('[data-cy-size-out]');
    const table = dlg.querySelector('[data-cy-size-table]');
    const pick = dlg.querySelector('[data-cy-pick]');
    let fit = 'same';
    let current = null;

    const render = () => {
      const a = advise(m, parseFloat(String(width.value).replace(',', '.')), fit);
      current = a ? a.best[0] : null;
      table.innerHTML = sizeTable(m, a && a.best);
      if (!a) {
        out.innerHTML = '';
        pick.hidden = true;
        return;
      }
      out.innerHTML = `<div class="cy-drawer__size-row"><span class="cy-drawer__badge">${current}</span><p class="cy-drawer__verdict">Nous vous conseillons le <strong>${current}</strong>.<br><span class="cy-drawer__fine">${a.note}</span></p></div>`;
      const found = findSizeInput(optionName, current);
      const unavailable = found && found.kind === 'radio' && found.el.dataset.optionAvailable === 'false';
      pick.hidden = !found;
      pick.disabled = Boolean(unavailable);
      pick.textContent = unavailable ? `Le ${current} n’est plus disponible dans ce coloris` : `Choisir le ${current}`;
    };

    pick.addEventListener('click', () => {
      /* Relu au clic : Horizon redessine le sélecteur à chaque changement de variante */
      const found = current && findSizeInput(optionName, current);
      if (found) {
        if (found.kind === 'radio') {
          if (!found.el.checked) found.el.click();
        } else {
          found.el.value = found.value;
          found.el.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      closeDrawer(dlg);
    });
    width.addEventListener('input', render);
    fits.forEach((b) => b.addEventListener('click', () => {
      fit = b.dataset.fit;
      fits.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      render();
    }));
    dlg.addEventListener('cy:drawer-open', render); /* le coloris a pu changer depuis la dernière ouverture */
    render();
  }

  function initDrawer(dlg) {
    dlg.classList.add('is-ready');
    dlg.querySelectorAll('[data-cy-close]').forEach((b) => b.addEventListener('click', () => closeDrawer(dlg)));
    dlg.addEventListener('click', (e) => { if (e.target === dlg) closeDrawer(dlg); }); /* clic à côté du panneau */
    dlg.addEventListener('cancel', (e) => { e.preventDefault(); closeDrawer(dlg); }); /* touche Échap */
    if (dlg.dataset.cyDrawer === 'delivery') initDeliveryDrawer(dlg);
    if (dlg.dataset.cyDrawer === 'size') initSizeDrawer(dlg);
  }

  /* Liens [data-cy-open] : ouvrent le tiroir s'il est sur la page ; sinon (ou sans JS) mènent à la page Aide */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-cy-open]');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
    const dlg = document.querySelector(`dialog[data-cy-drawer="${link.dataset.cyOpen}"]`);
    if (!dlg || typeof dlg.showModal !== 'function') return;
    e.preventDefault();
    if (!dlg.classList.contains('is-ready')) initDrawer(dlg); /* bloc redessiné par Horizon */
    openDrawer(dlg);
  });

  /* ---------- Page Aide ---------- */
  function initFaq(root) {
    const params = new URLSearchParams(location.search);
    const tabs = [...root.querySelectorAll('[data-cy-tab]')];
    const panels = [...root.querySelectorAll('[data-cy-panel]')];
    const items = [...root.querySelectorAll('[data-cy-qa]')];
    const input = root.querySelector('[data-cy-search]');
    const status = root.querySelector('[data-cy-status]');
    let current = tabs[0]?.dataset.cyTab;

    root.classList.add('is-enhanced');

    function select(cat) {
      current = cat;
      tabs.forEach((t) => t.setAttribute('aria-selected', String(t.dataset.cyTab === cat)));
      panels.forEach((p) => { p.hidden = p.dataset.cyPanel !== cat; });
      items.forEach((i) => { i.hidden = false; });
      root.classList.remove('is-searching');
      if (status) status.textContent = '';
    }

    function search() {
      const q = norm(input.value.trim());
      if (!q) { select(current); return; }
      const words = q.split(/\s+/);
      let hits = 0;
      root.classList.add('is-searching');
      tabs.forEach((t) => t.setAttribute('aria-selected', 'false'));
      panels.forEach((p) => { p.hidden = false; });
      items.forEach((i) => {
        const hay = norm(`${i.dataset.k} ${i.textContent}`);
        const ok = words.every((w) => hay.includes(w));
        i.hidden = !ok;
        if (ok) hits += 1;
      });
      panels.forEach((p) => { p.hidden = !p.querySelector('[data-cy-qa]:not([hidden])'); });
      const label = escapeHTML(input.value.trim());
      status.innerHTML = hits
        ? `${hits} réponse${hits > 1 ? 's' : ''} pour « ${label} »`
        : `Aucune réponse pour « ${label} ». Essayez un autre mot, ou écrivez-nous.`;
      if (hits === 1) items.find((i) => !i.hidden).open = true;
    }

    tabs.forEach((t) => t.addEventListener('click', () => { input.value = ''; select(t.dataset.cyTab); }));
    input?.addEventListener('input', search);
    root.querySelectorAll('[data-cy-chip]').forEach((c) =>
      c.addEventListener('click', () => { input.value = c.dataset.cyChip; search(); input.focus(); })
    );

    function openFromHash() {
      const id = decodeURIComponent(location.hash.slice(1));
      if (!id) return;
      /* v1.2 — #theme-livraison : ouvre l'onglet du thème (menu FAQ de l'en-tête) */
      if (id.startsWith('theme-')) {
        const tab = tabs.find((t) => t.dataset.cyTab === id.slice(6));
        if (tab) {
          input.value = '';
          select(tab.dataset.cyTab);
          const bar = tab.closest('[role="tablist"]') || tab;
          /* 96 px : place laissée à l'en-tête collant (comme scroll-margin-top des questions) */
          requestAnimationFrame(() => window.scrollTo({ top: bar.getBoundingClientRect().top + window.scrollY - 96 }));
        }
        return;
      }
      const qa = items.find((i) => i.id === id);
      if (qa) {
        input.value = '';
        select(qa.closest('[data-cy-panel]').dataset.cyPanel);
        qa.open = true;
        requestAnimationFrame(() => qa.scrollIntoView({ block: 'start' }));
      }
    }
    select(current);
    openFromHash();
    window.addEventListener('hashchange', openFromHash);

    /* Avis et liens copiables */
    root.addEventListener('click', (e) => {
      const vote = e.target.closest('[data-cy-vote]');
      if (vote) {
        vote.parentElement.innerHTML = vote.dataset.cyVote === 'oui'
          ? '<span class="cy-faq__thanks">Merci, c’est noté.</span>'
          : '<span class="cy-faq__thanks">Merci. Écrivez-nous : nous compléterons cette réponse.</span>';
      }
      const link = e.target.closest('[data-cy-link]');
      if (link) {
        const url = `${location.origin}${location.pathname}#${link.dataset.cyLink}`;
        navigator.clipboard?.writeText(url).then(() => { link.textContent = 'Lien copié'; }, () => { link.textContent = url; });
      }
      const copy = e.target.closest('[data-cy-copy]');
      if (copy) {
        navigator.clipboard?.writeText(copy.dataset.cyCopy).then(() => { copy.textContent = 'Adresse copiée'; });
      }
    });

    /* Estimateur */
    const est = root.querySelector('[data-cy-estimator]');
    if (est) {
      const sel = est.querySelector('select');
      const zones = [...est.querySelectorAll('[data-zone]')];
      let zone = 'fr';
      const piece = params.get('piece');
      if (piece && [...sel.options].some((o) => o.value === piece)) sel.value = piece;
      const step = ([k, v, s = '']) => `<li class="cy-faq__step"><span class="cy-faq__step-k">${k}</span><span class="cy-faq__step-v">${v}</span><span class="cy-faq__step-s">${s}</span></li>`;
      const render = () => {
        const e = estimate(sel.value, zone, new Date());
        est.querySelector('[data-cy-track]').innerHTML = e.steps.map(step).join('');
        est.querySelector('[data-cy-verdict]').innerHTML = e.verdict;
        est.querySelector('[data-cy-fine]').textContent = e.fine;
      };
      sel.addEventListener('change', render);
      zones.forEach((b) => b.addEventListener('click', () => {
        zone = b.dataset.zone;
        zones.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        render();
      }));
      render();
    }

    /* Guide des tailles */
    const sz = root.querySelector('[data-cy-size]');
    if (sz) {
      const model = sz.querySelector('select');
      const width = sz.querySelector('input');
      const fits = [...sz.querySelectorAll('[data-fit]')];
      const out = sz.querySelector('[data-cy-size-out]');
      const table = sz.querySelector('[data-cy-size-table]');
      let fit = 'same';
      const m0 = params.get('modele');
      if (m0 && SIZES[m0]) model.value = m0;
      const render = () => {
        const m = SIZES[model.value];
        const a = advise(m, parseFloat(String(width.value).replace(',', '.')), fit);
        table.innerHTML = sizeTable(m, a && a.best);
        if (!a) { out.innerHTML = '<p class="cy-faq__fine">Indiquez une largeur en centimètres.</p>'; return; }
        const best = a.best;
        out.innerHTML = `<div class="cy-faq__size-row"><span class="cy-faq__size-badge">${best[0]}</span><p class="cy-faq__verdict">Nous vous conseillons le <strong>${best[0]}</strong>.<br><span class="cy-faq__fine">${a.note}</span></p></div><p class="cy-faq__fine">Pas sûr·e ? Votre premier échange de taille est offert.</p>`;
      };
      model.addEventListener('change', render);
      width.addEventListener('input', render);
      fits.forEach((b) => b.addEventListener('click', () => {
        fit = b.dataset.fit;
        fits.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        render();
      }));
      render();
    }
  }

  function boot() {
    document.querySelectorAll('[data-cy-journey]:not(.is-dated)').forEach(initJourney);
    document.querySelectorAll('dialog[data-cy-drawer]:not(.is-ready)').forEach(initDrawer);
    document.querySelectorAll('[data-cy-faq]:not(.is-enhanced)').forEach(initFaq);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('variant:update', () => requestAnimationFrame(boot));
})();
